import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Table,
  Dimmer,
  Loader,
  Segment,
  Item,
  Divider,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import qs from 'qs';
import { decodeSearch } from '../../utils/url';
import { flashErrorMessage } from '../../actions/flash';
import * as endpoints from '../../constants/apiEndpoints';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { fetchAPI } from '../../actions/fetchM';

class LawyersReports extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    headerColor: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }).isRequired,
    onLoading: PropTypes.func,
    companyID: PropTypes.number,
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    return {
      currentPage,
    };
  }
  static getQueryData = (props) => {
    const query = decodeSearch(props.location.search);
    const projectID = query.projectID || '';
    const lawyerID = query.lawyerID || '';
    const firmName = query.firmName || '';
    return {
      projectID,
      lawyerID,
      firmName,
    };
  }
  constructor(props) {
    super(props);
    const state = LawyersReports.getPropsToState(props);
    this.state = {
      ...state,
      count: 0,
      data: [],
      limit: 0,
      loading: false,
      offset: 0,
    };
  }
  componentDidMount() {
    if (this.props.companyID > 0 && this.state.loading === false && this.state.data.length === 0) {
      this.fetchReports();
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = LawyersReports.getPropsToState(nextProps);
    const query = LawyersReports.getQueryData(this.props);
    const newQuery = LawyersReports.getQueryData(nextProps);
    const refetch = (
      !_.isEqual(query.projectID, newQuery.projectID) ||
      !_.isEqual(query.lawyerID, newQuery.lawyerID) ||
      !_.isEqual(query.firmName, newQuery.firmName) ||
      !_.isEqual(query.companyID, newQuery.companyID)
    );
    this.setState({ ...state }, () => {
      if (refetch) {
        const q = decodeSearch(nextProps.location.search);
        this.fetchReports(q);
      }
    });
  }
  componentDidUpdate() {
    if (this.props.companyID > 0 && this.state.loading === false && this.state.data.length === 0) {
      this.fetchReports();
    }
  }
  setComponentState(state = {}, cb) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
        if (cb) {
          cb();
        }
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
        if (this.props.onLoading) {
          this.props.onLoading(loading);
        }
      });
    });
  }
  getValueName = (value, arr) => {
    const valueName = arr.find(vn => vn.value === value);
    if (valueName && valueName.text) {
      return valueName.text;
    }
    return '';
  }
  generatePivot = (data) => {
    const pivot = [];
    data.forEach((d) => {
      if (d.cases_summary_count) {
        const pivotData = {
          dataSPA: [],
          dataLA: [],
          key: d.userID,
          rowSpan: 0,
          name: d.name,
          firm: d.firm,
        };
        const spa = d.cases_summary_count.SPA;
        const la = d.cases_summary_count.LA;
        pivotData.dataSPA = [
          {
            title: 'Pending Appointment',
            count: spa.PENDING_APPOINTMENT_COUNT.doc_count,
          },
          {
            title: 'SPA Signed Pending',
            count: spa.SPA_SIGNED_PENDING_COUNT.doc_count,
          },
          {
            title: 'SPA Signed',
            count: spa.SPA_SIGNED_COUNT.doc_count,
          },
          {
            title: 'SPA Received',
            count: spa.SPA_RECEIVED_COUNT.doc_count,
          },
          {
            title: 'Developer Signed',
            count: spa.DEVELOPER_SIGNED_COUNT.doc_count,
          },
          {
            title: 'Lawyer Collected',
            count: spa.LAWYER_COLLECTED_COUNT.doc_count,
          },
          {
            title: 'SPA Stamped',
            count: spa.SOLD_COUNT.doc_count,
          },
          {
            title: 'Developer Received',
            count: spa.DEVELOPER_RECEIVED_COUNT.doc_count,
          },
          {
            title: 'Developer Cancelled',
            count: spa.DEVELOPER_CANCELLED_COUNT.doc_count,
          },
          {
            title: 'Total SPA',
            count: spa.doc_count,
          },
        ];
        pivotData.dataLA = [
          {
            title: 'New',
            count: la.NEW_COUNT.doc_count,
          },
          {
            title: 'LA Signed By Borrower',
            count: la.LA_SIGNED_BY_BORROWER_COUNT.doc_count,
          },
          {
            title: 'LA Signed By Bank',
            count: la.LA_SIGNED_BY_BANK_COUNT.doc_count,
          },
          {
            title: 'LOU Signed & Issued',
            count: la.LOU_SIGNED_ISSUED_COUNT.doc_count,
          },
          {
            title: 'LA Stamped',
            count: la.LA_STAMPED_COUNT.doc_count,
          },
          {
            title: 'Advice Bank for 1st Draw Down',
            count: la.ADVICE_BANK_COUNT.doc_count,
          },
          {
            title: '1st Disbursement',
            count: la.FIRST_DISBURSEMENT_COUNT.doc_count,
          },
          {
            title: 'Developer Cancelled',
            count: la.DEVELOPER_CANCELLED_COUNT.doc_count,
          },
          {
            title: '',
            count: '',
          },
          {
            title: 'Total LA',
            count: la.doc_count,
          },
        ];
        pivotData.rowSpan = pivotData.dataSPA.length;
        if (pivotData.dataLA.length > pivotData.dataSPA.length) {
          pivotData.rowSpan = pivotData.dataLA.length;
        }
        pivot.push(pivotData);
      }
    });
    return pivot;
  }
  getDataTitle = (title) => {
    const { t } = this.props;
    if (title === '') {
      return title;
    }
    return t(title, { ns: namespaces[title === 'Total LA' || title === 'Total SPA' ? 0 : 1] });
  }

  async fetchReports(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({}, q);
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.LAWYER_REPORT_CASES_SUMMARY_COUNT(this.props.companyID)}/?${qs.stringify(query)}`, null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }

    if (res) {
      const data = this.generatePivot(res);
      await this.setComponentState({
        data,
      });
    } else {
      this.setState({ data: [] });
    }

    await this.setLoading(false);
  }
  renderRow = data => (
    data.map(pivoted => (
      pivoted.dataSPA.map((pivotedData, pdid) => (
        <Table.Row
          key={pdid}
          style={(pivoted.dataSPA.length === pdid + 1) ? { borderBottom: '#bbb 2px solid' } : {}}
        >
          {
            (pivoted.rowSpan && pdid === 0) &&
            <Table.Cell
              rowSpan={pivoted.rowSpan}
              style={{ borderBottom: '#bbb 2px solid' }}
            >
              <h4>
                {pivoted.name}
                <br />
                <small>
                  {pivoted.firm}
                </small>
              </h4>
            </Table.Cell>
          }
          <Table.Cell style={pivotedData.title === 'Total SPA' ? { fontWeight: 'bold' } : {}}>
            {this.getDataTitle(pivotedData.title)}
          </Table.Cell>
          <Table.Cell textAlign="right" style={pivotedData.title === 'Total SPA' ? { fontWeight: 'bold' } : {}}>
            {pivotedData.count}
          </Table.Cell>
          <Table.Cell style={pivoted.dataLA[pdid].title === 'Total LA' ? { fontWeight: 'bold' } : {}}>
            {this.getDataTitle(pivoted.dataLA[pdid].title)}
          </Table.Cell>
          <Table.Cell textAlign="right" style={pivoted.dataLA[pdid].title === 'Total LA' ? { fontWeight: 'bold' } : {}}>
            {pivoted.dataLA[pdid].count}
          </Table.Cell>
        </Table.Row>
      ))
    ))
  );
  render() {
    const { data } = this.state;
    const { t } = this.props;
    return (
      <Grid style={{ margin: '-1rem 0' }}>
        <Grid.Row>
          <Grid.Column>
            <Segment color={this.props.headerColor}>
              <Grid>
                <Grid.Row className="users-bookings table">
                  <Grid.Column className="mobile-report-table">
                    <Dimmer
                      inverted style={{ zIndex: 20 }}
                      active={this.state.loading}
                    >
                      <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                    </Dimmer>
                    {
                      data && data.length > 0 ?
                        <Table
                          celled
                          compact
                          unstackable
                          structured
                          sortable
                          style={{ marginTop: 0 }}
                        >
                          <Table.Header>
                            <Table.Row
                              style={{ borderBottom: '#bbb 2px solid' }}
                            >
                              <Table.HeaderCell sorted="ascending">{t('Lawyer')}</Table.HeaderCell>
                              <Table.HeaderCell>{t('SPA Status')}</Table.HeaderCell>
                              <Table.HeaderCell textAlign="right">{t('Count')}</Table.HeaderCell>
                              <Table.HeaderCell>{t('LA Status')}</Table.HeaderCell>
                              <Table.HeaderCell textAlign="right">{t('Count')}</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {this.renderRow(data)}
                          </Table.Body>
                        </Table>
                      : (
                        <Item>
                          <Item.Content>
                            <Segment textAlign="center">
                              {
                                this.state.loading ? <Divider hidden />
                                : `${t('No reports found')}.`
                              }
                            </Segment>
                          </Item.Content>
                        </Item>
                      )
                    }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(LawyersReports);



// WEBPACK FOOTER //
// ./src/components/Reports/LawyersReports.jsx